import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

export default {

  state() {
    return {
      numeration: null,
      listInvoices: null,
      creditNoteNumeration: null,
    };
  },
  mutations,
  actions,
  getters
}